/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * 'bookable' = has an available slot (can be booked now); 'none' = approved but not bookable yet (no slots, or all past / full / busy). A result with availability other than bookable cannot be booked now.
 */
export enum ActivityFeaturedAvailability {
  bookable = 'bookable',
  none = 'none'
}
